export default __webpack_public_path__ + "static/media/emptypanel.2e0811c7.svg";